module.exports = __webpack_public_path__ + "img/光伏概览.e5f9827e.png";